import styled from 'styled-components';
import { colors } from 'styles/colors';
import DefaultImageCropped from '../../../../../assets/img/DefaultImageUnitCrop.png';
import StateBackground from '../../../../../assets/img/overview/stateBackground.svg';

export const InfoCardContainer = styled.div`
  width: 244px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 16px;

  & > div > h5 {
    font-weight: 700;
    font-size: 12px;
    color: ${colors.text['main-900']};
    line-height: 100%;
  }


  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ImageHeader = styled.div`
  background-size: cover;
  background-position: center;

  width: 212px;
  height: 69px;
  padding: 10px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: start;

  & > button {
    padding: 0;
    margin: 0;
    border: 0;
    margin-left: auto;
    background-color: transparent;
  }

  & > div {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const UnitImageHeader = styled(ImageHeader)`
  background-image: linear-gradient(12.19deg, #0F0F36 30%, rgba(15, 15, 54, 0.4) 70.51%, rgba(15, 15, 54, 0.6) 89.95%), url(${DefaultImageCropped});

`;

export const StateImageHeader = styled(ImageHeader)`
  background-image: linear-gradient(rgba(10, 13, 20, 0.4), rgba(10, 13, 20, 0.4)), url(${StateBackground});
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ListContainer = styled(TotalContainer)`
  gap: 8px;
`;

export const Circle = styled.div<{color: string}>`
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background-color: ${({ color }) => color};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;

  & > li {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: start;

    & > span {
      font-size: 12px;
      font-weight: 400;
      color: ${colors.text['main-900']};
      line-height: 150%;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const TitleHeader = styled.h4<{scope: 'state' | 'unit'}>`
  margin: 0;
  font-weight: 600;
  line-height: 150%;
  color: ${colors.text['white-0']};

  ${({ scope }) => (scope === 'state' ? `
    font-size: 24px;
  ` : `
    font-size: 16px;
    margin-top: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `)}
`;

export const SubTitleHeader = styled.span`
  display: block;
  font-size: 12px;
  color: ${colors.text['white-0']};
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: -4px;
`;
